var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08613 11.661L0.389129 6.96496C-0.129632 6.44631 -0.129721 5.60532 0.388929 5.08656C0.388963 5.08652 0.388996 5.08649 0.389029 5.08646C0.907815 4.56767 1.74891 4.5676 2.26778 5.08631L5.08613 7.90376L12.6003 0.38909C13.119 -0.129671 13.96 -0.129701 14.4788 0.389024C14.4788 0.389035 14.4788 0.389046 14.4788 0.389057C14.9976 0.907822 14.9976 1.7489 14.4789 2.26768L5.08613 11.661Z",
    fill: "#6AC259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCheckIcon);
export default __webpack_public_path__ + "static/media/selectCheckIcon.0ebd6f2db00e5aa532146a5941468e09.svg";
export { ForwardRef as ReactComponent };